<template>
  <div class="carousel">
    <swiper :options="swiperOption">
      <swiper-slide v-for="(item, index) of imgArr" :key="index" class="swiper-slide">
        <a href="javascript:;" class="img-box">
          <img :src="item.url" alt="">
        </a>
        <ul class="img-content">
            <li class="df-left">
              <p class="title-line"></p>
              <p class="img-title">{{item.title}}</p>
            </li>
            <li class="df-left">
              <p class="titleContent">{{item.titleContent}}</p>
              <p class="line">|</p>
              <p class="content">{{item.content}}</p>
            </li>
          </ul>
      </swiper-slide>
    </swiper>
    <div class="swiper-pagination"  slot="pagination"></div>
    <div class="swiper-button-prev" slot="button-prev"></div>
    <div  class="swiper-button-next" slot="button-next"></div>
  </div>
</template>

<script>
import 'swiper/dist/css/swiper.css'
import bg1 from '../assets/images/1.png'
import bg2 from '../assets/images/2.png'
import bg3 from '../assets/images/3.png'
export default {
  name: 'carousel',
  data () {
    return {
      swiperOption: {
        // 如果需要分页器
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          clickable: true, // 此参数设置为true时，点击分页器的指示点分页器会控制Swiper切换。
          hideOnClick: true // 默认分页器会一直显示。这个选项设置为true时点击Swiper会隐藏/显示分页器。
        },
        notNextTick: true,
        // 如果需要自动播放
        autoplay: {
          delay: 3000,
          disableOnInteraction: false // 用户操作swiper之后，是否禁止autoplay。
          // reverseDirection: true,   //开启反向自动轮播。
        },
        // 如果需要前进后退按钮
        navigation: {
          nextEl: '.swiper-button-next', // 前进按钮的css选择器或HTML元素。
          prevEl: '.swiper-button-prev', // 后退按钮的css选择器或HTML元素。
          hideOnClick: true // 点击slide时显示/隐藏按钮
        }
      },
      imgArr: [
        {'url': bg1, 'title': '高可用、高扩展、高集成', 'titleContent': '高可用、高扩展、高集成', content: 'Highly available, highly scalable, highly integrated'},
        {'url': bg2, 'title': '大产业、大数据、大趋势', 'titleContent': '大产业、大数据、大趋势', content: 'Highly available, highly scalable, highly integrated'},
        {'url': bg3, 'title': '新时代、新零售、新创想', 'titleContent': '新时代、新零售、新创想', content: 'New era, new retail, new ideas'}
      ]
    }
  },
  mounted () {
  }
}
</script>

<style scoped>
  .carousel{
    width: 100%;
    height: 580px;
    background: #000;
    position: relative;
    font-size: 16px;
    overflow-y: hidden;
  }
  .swiper-pagination{
    position: absolute;
    bottom: 5%;
    left: 50%;
    transform: translateX(-50%);
  }
  .swiper-pagination >>> .swiper-pagination-bullet {
    margin-right: 10px;
    width: 41px;
    height: 4px;
    background: rgba(255,255,255, 1);
    border-radius: 0;
    opacity: .3;
    outline: none;
  }
  .swiper-pagination >>> .swiper-pagination-bullet:last-child {
    margin-right: 0;
  }
  .swiper-pagination >>> .swiper-pagination-bullet-active {
    background: rgba(255,255,255,1);
    opacity: 1;
  }
  .swiper-button-prev{
    left: 10%;
    background-image: url('../assets/images/left.png');
    background-size: 50%;
  }
  .swiper-button-next{
    right: 10%;
    background-image: url('../assets/images/right.png');
    background-size: 50%;
  }
  .swiper-button-next, .swiper-button-prev{
    width: 52px;
    height: 52px;
    background-color: rgba(255, 255, 255, .34);
    outline: none;
  }
  .swiper-slide img{
    width: 100%;
  }
  .img-box{
    position: relative;
  }
  .img-content{
    position: absolute;
    top: 250px;
    left: 300px;
  }
  .df-left{
    display: flex;
    justify-content: left;
    align-items: center;
  }
  .img-title{
    font-size:59px;
    font-family:YouSheBiaoTiHei;
    font-weight:400;
    line-height:90px;
    color:rgba(255,255,255,1);
    margin-bottom: 10px;
  }
  .titleContent{
    font-family:PingFang SC;
    font-weight:400;
    line-height:30px;
    color:rgba(255,255,255,1);
    font-size:20px;
    margin-left: 35px;
  }
  .content{
    font-size:20px;
    font-family:PingFang SC;
    font-weight:400;
    line-height:30px;
    color:rgba(255,255,255,1);
    opacity:0.27;
  }
  .line{
    padding: 0 10px;
    color: rgba(178,176,188,1);
  }
  .title-line{
    margin-right: 20px;
    width:15px;
    height:44px;
    background:rgba(252,189,1,1);
    opacity:1;
    transform: skew(-20deg);
  }
</style>



// WEBPACK FOOTER //
// src/components/carousel.vue